import type { Context } from '@app/packages/actionContext/Context'

import type { StoreDispatch } from './dispatch'

/** wrapper for ThunkAction adapted to application */
export type ThunkAction<R extends any> = (dispatch: StoreDispatch, getState: () => unknown, context: Context) => R

export const createThunk = <R extends any>(action: ThunkAction<R>): ThunkAction<R> => action
